import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared AI file-parse hook: uploads a file to a parse endpoint, returns parsed payload
export const useAiFileParse = (endpoint) => {
  const { getAuthHeader } = useAuth();
  const [uploading, setUploading] = useState(false);

  const parse = async (file) => {
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axios.post(`${API}${endpoint}`, formData, {
        headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      });
      return res.data;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to parse file');
      return null;
    } finally {
      setUploading(false);
    }
  };

  return { uploading, parse };
};

export default useAiFileParse;
